import React from 'react';

import { FormattedMessage } from '../../markdown/FormattedMessage';
import type { TextBlock } from '../types';

interface TextBlockComponentProps {
  block: TextBlock;
  isStreaming?: boolean;
}

export const TextBlockComponent = ({ block, isStreaming }: TextBlockComponentProps) => {
  return <FormattedMessage message={{ content: block.text }} isStreaming={isStreaming} />;
};
